import { z } from 'zod'

//
// 発注照合（大和ハウス向け）のステータス・分類。
// Prisma enum（packages/backend/integrations/src/db/schema.prisma）と値を一致させること。
// ドメイン仕様: docs/domain/order_matching/04_matching_logic.md
//

// 発注の分類。ソース（デリバリー管理表 / SCRM）の中の分類であり、ソースそのものではない
export const steelOrderCategorySchema = z.enum(['roll', 'spot'])
export type SteelOrderCategory = z.infer<typeof steelOrderCategorySchema>

export const steelOrderCategoryLabels: Record<SteelOrderCategory, string> = {
  roll: 'ロール品',
  spot: 'スポット品',
}

// ミルシートステータス / 発注ステータス共通の照合結果。
// 画面上の「対象外」はステータス値ではなく isMillsheetExcluded フラグで表現する
export const steelOrderMatchingStatusSchema = z.enum(['completed', 'incomplete', 'unregistered'])
export type SteelOrderMatchingStatus = z.infer<typeof steelOrderMatchingStatusSchema>

export const steelOrderMatchingStatusLabels: Record<SteelOrderMatchingStatus, string> = {
  completed: '完了',
  incomplete: '未完了',
  unregistered: '未登録',
}

export const steelOrderQualityCheckStatusSchema = z.enum(['completed', 'unregistered'])
export type SteelOrderQualityCheckStatus = z.infer<typeof steelOrderQualityCheckStatusSchema>

export const steelOrderQualityCheckStatusLabels: Record<SteelOrderQualityCheckStatus, string> = {
  completed: '完了',
  unregistered: '未登録',
}
